export const DateConverter = (dateString) => {
  const d = new Date(dateString);
  return d.toDateString();
};


export const DateTimeConverter = (dateTimeString) => {
  const d = new Date(dateTimeString);

  const day = d.getDate().toString().padStart(2, '0');
  const month = d.toLocaleString('default', { month: 'short' }); // Abbreviated month name
  const year = d.getFullYear();
  const time = d.toLocaleTimeString([], { hour12: false }); // 24-hour format

  return `${day}/${month}/${year} ${time}`;
};
